<template>
  <div class="dataForm" style="min-width:800px;">
    <el-form
    ref="dataForm"
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    label-width="100px"
    class="mb-20"
    >
      <div class="underlineForm">
        <el-form-item label="业务名称" prop="businessId">
          <el-select class="filter-item" :filterable="true" v-model="ruleForm.businessId" placeholder="输入关键字搜索">
            <template v-if="businessOption.length">
              <el-option
                v-for="item in businessOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外包公司" prop="outsourceCompanyId">
          <el-select class="filter-item" :filterable="true" v-model="ruleForm.outsourceCompanyId" placeholder="输入关键字搜索">
            <template v-if="outsourceCompanyOption.length">
              <el-option
                v-for="item in outsourceCompanyOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外包公司账户" prop="account">
          <el-select :filterable="true" v-model="ruleForm.account" class="filter-item" placeholder="输入关键字搜索" clearable value-key="alias" @focus="loadOutsourceCompanyAccount()">
            <template v-if="outsourceCompanyAccountOption.length">
              <el-option
                v-for="(item, index) in outsourceCompanyAccountOption"
                :key="item.id || index"
                :label="item.alias"
                :value="item"
              />
            </template>
            <el-option
              v-else
              :value="-1"
              disabled
            >
              暂无数据
            </el-option>
            <!-- <template v-slot:empty>
              <p class="el-select-dropdown__empty">该外包公司没有账户信息</p>
            </template> -->
          </el-select>
        </el-form-item>
        <el-form-item label="总费用" prop="fee">
          <el-input-number v-model="ruleForm.fee" type="input" class="filter-item" :precision="2" controls-position="right" @change="handleFeeChange"></el-input-number>
        </el-form-item>
        <el-form-item label="数量" prop="amount">
          <el-input v-model="ruleForm.amount" type="text" class="filter-item" clearable :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="单价" prop="unitPrice">
         <el-input-number v-model="ruleForm.unitPrice" type="input" class="filter-item" :precision="2" controls-position="right" disabled></el-input-number>
        </el-form-item>
        <el-form-item label="是否含税" prop="containsRate">
          <el-select class="filter-item" :filterable="true" v-model="ruleForm.containsRate" @change="handleContainsRateChange" placeholder="输入关键字搜索" clearable>
            <template v-if="containsRateOption.length">
              <el-option
                v-for="item in containsRateOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
         </el-select>
        </el-form-item>
        <template v-if="ruleForm.containsRate">
          <el-form-item label="发票类型" prop="invoiceType">
            <el-select class="filter-item" :filterable="true" v-model="ruleForm.invoiceType" placeholder="输入关键字搜索" clearable>
            <template v-if="invoiceTypeOption.length">
              <el-option
                v-for="item in invoiceTypeOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
           </el-select>
          </el-form-item>
          <el-form-item label="税率" prop="rate">
            <el-select class="filter-item" :filterable="true" v-model="ruleForm.rate" placeholder="输入关键字搜索" clearable>
            <template v-if="rateOption.length">
              <el-option
                v-for="item in rateOption"
                :key="item.id"
                :label="item.mark"
                :value="item.rate"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
           </el-select>
          </el-form-item>
        </template>
        <el-form-item label="备注" prop="mark" class="fullWidth">
          <el-input v-model="ruleForm.mark" type="textarea" class="filter-item" clearable></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div class="dialog-footer mt-20 " v-if="mode !== 'approval'">
      <el-button @click="cancle" >
        {{ t("table.cancel") }}
      </el-button>
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="handleSubmit"
      >
        {{ t("table.confirm") }}
      </el-button>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, ref, onMounted, nextTick, unref } from 'vue'
import { ArrayRowsItem } from '@/model/Index'
import { getPageList } from '@/apis/Form'

import { ElMessage, ElForm } from 'element-plus'
import { getDetailById } from '@/apis/Dictionary'

import { createOutsourceFee, updateOutsourceFee } from '@/apis/OutsourceFee'
import { useI18n } from 'vue-i18n'
import $number from 'number-precision'

export default defineComponent({
  components: {
  },
  props: {
    id: { type: Number, required: false, default: 0 },
    dialogFormVisible: { type: Boolean, required: true },
    api: { type: String, required: true },
    from: { type: String, required: false, default: 'invoice' },
    selectcCustomerCompanyId: { type: String, required: false, default: '' },
    selectcCustomerTitleId: { type: String, required: false, default: '' },
    mode: { type: String, required: false, default: '' },
    businessDetail: { type: Object, required: false, default: null }
  },
  emits: ['update:visibel', 'submit'],

  setup(props, context) {
    const { t } = useI18n()

    const dataForm = ref(ElForm)
    const BusinessList = ref({})

    const dataMap = reactive({
      from: props.from,
      mode: props.mode,
      submitLoading: false,
      ruleForm: {
        businessId: '',
        outsourceCompanyId: '',
        account: '' as any,
        fee: null as any,
        containsRate: '' as string | boolean,
        invoiceType: '' as string | number,
        rate: '' as string | number,
        amount: props.businessDetail.amount,
        unitPrice: 0
      },
      rules: {
        outsourceCompanyId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        account: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        fee: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        containsRate: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        invoiceType: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        rate: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },
      businessOption: [],
      outsourceCompanyOption: [],
      outsourceCompanyAccountOption: [],
      containsRateOption: [],
      selectcCustomerTitleId: props.selectcCustomerTitleId,
      invoiceTypeOption: [],
      rateOption: [],

      handleBusinessId(value: any) {
        dataMap.ruleForm.businessId = ''
        if (value) {
          const outsourceCompany = dataMap.outsourceCompanyOption.find(j => j.id === value) || {}
          dataMap.ruleForm.businessId = outsourceCompany.id
        }
      },
      loadOutsourceCompanyAccount() {
        if (!dataMap.ruleForm.outsourceCompanyId) {
          return
        }
        getPageList(`outsourceCompany/${dataMap.ruleForm.outsourceCompanyId}`).then((res: any) => {
          dataMap.outsourceCompanyAccountOption = res.accounts
            ? res.accounts.map((item: any) => {
              return {
                ...item
              }
            })
            : []
          // dataMap.ruleForm.account = dataMap.outsourceCompanyAccountOption[0]
        })
      },
      getInvoiceType() {
        getPageList('dropdown/InvoiceType').then((res: any) => {
          dataMap.invoiceTypeOption = res || []
        })
      },
      getRateOption() {
        getPageList('feeRate/dropdowns').then((res: any) => {
          dataMap.rateOption = res
            ? res.map((item: any) => {
              return {
                rate: item,
                mark: `${item}%`
              }
            })
            : []
        })
      },
      cancle() {
        context.emit('update:visibel')
      },
      handleSubmit() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              const tempData = {
                businessId: dataMap.ruleForm.businessId,
                outsourceCompanyId: dataMap.ruleForm.outsourceCompanyId,
                account: dataMap.ruleForm.account,
                fee: dataMap.ruleForm.fee,
                containsRate: dataMap.ruleForm.containsRate,
                invoiceType: dataMap.ruleForm.invoiceType,
                rate: dataMap.ruleForm.rate
              }
              const formSate = !props.id ? 'add' : 'edit'
              if (formSate === 'add') {
                await createOutsourceFee(tempData)
              } else {
                await updateOutsourceFee(props.id, tempData)
              }
              dataMap.submitLoading = false
              context.emit('update:visibel')
              context.emit('submit')
              ElMessage({
                message: !props.id ? '创建成功' : '编辑成功',
                type: 'success',
                duration: 2000
              })
            } catch (err:any) {
              console.log(err, 'err')
              dataMap.submitLoading = false
              if (err && err.errors) {
                err.errors.forEach((item: any) => {
                  const field = dataMap.rules[item.field][0]
                  if (field) {
                    field.message = null
                    nextTick(() => {
                      field.message = item.defaultMessage
                    })
                  }
                })
              }
            }
          }
        })
      },
      clearValidate() {
        nextTick(() => {
          (dataForm.value as typeof ElForm).clearValidate()
        })
      },
      handleContainsRateChange(val: any) {
        // 只在新增模式下设置默认值
        if (val === true && !props.id) {
          dataMap.ruleForm.invoiceType = 1 // 增值税发票
          dataMap.ruleForm.rate = 13 // 13%
        }
        // 选择"否"时不清空，保留用户之前选择的值
      },

      handleFeeChange() {
        const { fee, amount } = dataMap.ruleForm
        dataMap.ruleForm.unitPrice = $number.divide(fee * 1, amount * 1)
      }
    })
    onMounted(() => {
      dataMap.getInvoiceType()
      dataMap.getRateOption()
      dataMap.businessOption = [{
        id: props.businessDetail.id,
        name: props.businessDetail.name
      }]
      dataMap.outsourceCompanyOption = [{
        id: props.businessDetail.outsourceCompanyId,
        name: props.businessDetail.outsourceCompanyName
      }]
      dataMap.ruleForm.businessId = props.businessDetail.id
      dataMap.ruleForm.outsourceCompanyId = props.businessDetail.outsourceCompanyId
      dataMap.containsRateOption = [{
        name: '是',
        id: true
      }, {
        name: '否',
        id: false
      }]
      if (props.id) {
        getDetailById(props.api, props.id).then((res: any) => {
          dataMap.ruleForm = res
          dataMap.loadOutsourceCompanyAccount()
        })
      }
      dataMap.clearValidate()
    })
    return { t, ...toRefs(dataMap), dataForm, BusinessList }
  }
})
</script>
